import { useMemo } from 'react';
import { SortContext } from './SortContext.js';
import { jsx } from 'react/jsx-runtime';

function SortProvider(props) {
  var children = props.children,
    id = props.id,
    order = props.order,
    onSort = props.onSort,
    hideColRows = props.hideColRows;
  return /*#__PURE__*/jsx(SortContext.Provider, {
    value: useMemo(function () {
      return {
        id: id,
        order: order,
        onSort: onSort,
        hideColRows: hideColRows
      };
    }, [id, order, onSort, hideColRows]),
    children: children
  });
}

export { SortProvider };
